import React, { useState } from 'react';
import { TestSet, Question } from '../../types/models';
import { Button } from '../common/Button';

interface EditTestSetProps {
  testSet: TestSet;
  allQuestions: Question[];
  onSave: (updated: { name?: string; questions_ids?: string[] }) => Promise<void>;
  onCancel: () => void;
}

export const EditTestSet: React.FC<EditTestSetProps> = ({ testSet, allQuestions, onSave, onCancel }) => {
  const [name, setName] = useState(testSet.name);
  const [selectedIds, setSelectedIds] = useState<string[]>(testSet.questions.map(q => q.id));
  const [isSaving, setIsSaving] = useState(false);

  const handleCheckbox = (id: string) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(qid => qid !== id) : [...prev, id]);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSaving(true);
    await onSave({ name, questions_ids: selectedIds });
    setIsSaving(false);
  };

  return (
    <form onSubmit={handleSubmit} style={{ background: '#f8f8f8', padding: 16, borderRadius: 8, marginBottom: 16 }}>
      <h4>Edytuj zestaw pytań</h4>
      <label>
        Nazwa zestawu:
        <input value={name} onChange={e => setName(e.target.value)} required style={{ marginLeft: 8 }} />
      </label>
      <div style={{ margin: '12px 0' }}>
        <strong>Wybierz pytania:</strong>
        <ul style={{ maxHeight: 200, overflowY: 'auto', padding: 0, listStyle: 'none' }}>
          {allQuestions.map(q => (
            <li key={q.id}>
              <label>
                <input
                  type="checkbox"
                  checked={selectedIds.includes(q.id)}
                  onChange={() => handleCheckbox(q.id)}
                />
                {q.text}
              </label>
            </li>
          ))}
        </ul>
      </div>
      <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
        <Button type="submit" disabled={isSaving}>Zapisz</Button>
        <Button type="button" variant="secondary" onClick={onCancel}>Anuluj</Button>
      </div>
    </form>
  );
};
